"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.composeGaugeComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _src = require("../libs/victory-gauge/src");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var composeGaugeComponent = function composeGaugeComponent(args) {
    var VictoryGauge = (0, _src.composeVictoryGauge)(args);

    var GaugeComponent = function (_React$Component) {
        _inherits(GaugeComponent, _React$Component);

        function GaugeComponent(props) {
            _classCallCheck(this, GaugeComponent);

            var _this = _possibleConstructorReturn(this, (GaugeComponent.__proto__ || Object.getPrototypeOf(GaugeComponent)).call(this, props));

            _this._getSegments = function () {
                return [_this.props.minValue, _this.props.highValue, _this.props.maxValue].sort();
            };

            _this._getTicksValue = function () {
                var count = 5;
                var delta = (_this.props.maxValue - _this.props.minValue) / count;
                var labels = [];
                for (var i = 0; i <= count; i++) {
                    labels.push(_this.props.minValue + i * delta);
                }

                if (process.env.IS_WEB) {
                    return labels;
                } else {
                    // return [];
                    return [_this.props.minValue, _this.props.maxValue];
                }
            };

            _this.state = {
                duration: 0,
                endAngle: -90
            };
            return _this;
        }

        _createClass(GaugeComponent, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    duration: this.props.duration,
                    endAngle: 90
                });
            }
        }, {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return nextProps.currentValue !== this.props.currentValue || nextProps.maxValue != this.props.maxValue || nextProps.minValue != this.props.minValue || nextProps.highValue != this.props.highValue || nextProps.hideNeedle != this.props.hideNeedle || nextState.endAngle != this.state.endAngle;
            }
        }, {
            key: "render",
            value: function render() {
                return _react2.default.createElement(VictoryGauge, {
                    style: {
                        parent: this.props.style.parent,
                        labels: { fontSize: 2, padding: 100 }
                    },
                    hideNeedle: this.props.hideNeedle,
                    endAngle: this.state.endAngle,
                    data: this.props.currentValue,
                    tickFormat: function tickFormat(x) {
                        return "" + x;
                    },
                    tickValues: this._getTicksValue(),
                    segments: this._getSegments(),
                    colorScale: this.props.colorScale
                });
            }
        }]);

        return GaugeComponent;
    }(_react2.default.Component);

    GaugeComponent.propTypes = {
        tickValues: _react2.default.PropTypes.array,
        colorScale: _react2.default.PropTypes.array,
        duration: _react2.default.PropTypes.number,
        currentValue: _react2.default.PropTypes.number,
        minValue: _react2.default.PropTypes.number,
        highValue: _react2.default.PropTypes.number,
        maxValue: _react2.default.PropTypes.number,
        hideNeedle: _react2.default.PropTypes.bool,
        style: _react2.default.PropTypes.object
    };

    GaugeComponent.defaultProps = {
        colorScale: ["#faa23b", "#94ca64"],
        duration: 500,
        minValue: 0,
        highValue: 75,
        maxValue: 100,
        hideNeedle: false,
        style: {
            parent: {
                maxWidth: "100%"
            }
        }
    };

    return GaugeComponent;
};

exports.composeGaugeComponent = composeGaugeComponent;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-charts/lib/charts/gauge/GaugeComponent.js
// module id = 1146
// module chunks = 0